<template>
	<div>
	<h1 class="mb-4">{{ title }}</h1>
		<v-filters
			class="mb-4"
			v-bind="{
				filters: urlFilters,
				clientsTariffs: CLIENTS_TARIFFS,
				loading
			}"
			@update-filters="updateUrl"
		/>
		<div class="d-flex align-center">
			<v-btn
				class="mr-4"
				@click="downloadCsv"
			>
				Экспорт CSV
			</v-btn>

			<v-checkbox
				v-model="showOnlyOverrun"
				label="Показать клиентов с перерасходом"
				dense
				hide-details
				class="mt-0 pt-0"
			/>
		</div>

		<v-data-table
			class="clients-statistics-table"
			:headers="headers"
			:items="filteredTableItems"
			:loading="loading.table"
			disable-pagination
			hide-default-footer
			fixed-header
			height="calc(100vh - 225px)"
		>
			<template v-slot:item.data_unit_limit="{ item }">
				<v-text-field
					:value="item.data_unit_limit ?? ''"
					dense
					outlined
					hide-details
					type="number"
					@input="val => item.data_unit_limit = val"
					@keydown.enter="$event.target.blur(); updateLimit(item, item.data_unit_limit)"
				/>
			</template>
			<template v-slot:item.overrun="{ item }">
				<div
					:class="{
      'overrun-red': item.data_unit_limit !== 0 && item.overrun
				}"
				>
					{{ item.overrun }}
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import filters from './filters.vue'
import { validateFilterFromOptions } from '@/function/validateFilter'
import updateUrlMixin from '@/mixins/updateUrlMixin'
import { NOTIFY_STATUS } from '@/const'
import errors from '@/store/errors'

const CLIENTS_TARIFFS = [
	{ text: 'Не выбран', value: 0 },
	{ text: 'Base', value: 1 },
	{ text: 'Pro', value: 2 },
	{ text: 'Premium', value: 3 },
	{ text: 'Специальный', value: 4 },
	{ text: 'Enterprise', value: 5 },
	{ text: 'Demo', value: 6 },
	{ text: 'Position', value: 7 },
	{ text: 'Position Plus', value: 8 }
]

export default {
	name: 'clientsStatistics',
	components: {
		'v-filters': filters
	},
	mixins: [updateUrlMixin],

	metaInfo () {
		return {
			title: this.title
		}
	},

	data () {
		return {
			title: 'Клиентские лимиты',
			CLIENTS_TARIFFS,
			monthMenu: false,
			selectedMonth: null,
			clientSearch: '',
			filters: {
				only_active_clients: 1
			},
			showInactive: false,
			showOnlyOverrun: false,
			headers: [
				{
					text: 'ID клиента',
					value: 'client_id',
					align: 'center',
					divider: true
				},
				{
					text: 'Имя клиента',
					value: 'client_name',
					align: 'center',
					divider: true
				},
				{
					text: 'Перерасход',
					value: 'overrun',
					align: 'center',
					divider: true
				},
				{
					text: 'Лимит',
					value: 'data_unit_limit',
					align: 'center',
					divider: true,
					width: '140px'
				},
				{
					text: 'Тариф',
					value: 'tariff',
					align: 'center',
					divider: true
				},
				{
					text: 'Data-unit',
					value: 'data_unit',
					align: 'center',
					divider: true
				},
				{
					text: 'WS-unit',
					value: 'ws_unit',
					align: 'center',
					divider: true
				},
				{
					text: 'WS-unit google',
					value: 'ws_unit_google',
					align: 'center',
					divider: true
				},
				{
					text: 'WS-unit yandex',
					value: 'ws_unit_yandex',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-unit',
					value: 'serp_unit',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-unit google',
					value: 'serp_unit_google',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-unit yandex',
					value: 'serp_unit_yandex',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-send',
					value: 'send_serp_data',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-send yandex',
					value: 'send_serp_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'Serp-send google',
					value: 'send_serp_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'WS-send',
					value: 'send_ws_data',
					align: 'center',
					divider: true
				},
				{
					text: 'WS-send yandex',
					value: 'send_ws_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'Ws-send google',
					value: 'send_ws_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'Send all',
					value: 'send_all_data',
					align: 'center',
					divider: true
				}
			],
			loading: {
				table: true,
				clients: true
			}
		}
	},

	computed: {
		...mapState({
			clientsStatisticsData: state => state.clientsStatistics.clientsStatisticsData?.items || [],
			clients: state => state.clients
		}),

		tableItems () {
			return this.clientsStatisticsData.map(item => {
				return {
					...item,
					client_id: item.client_id,
					client_name: item.client_name,
					tariff: item.tariff,
					data_unit: item.current.unit_cnt,
					ws_unit: item.current.ws_unit_cnt,
					ws_unit_google: item.current.google_ws_unit_cnt,
					ws_unit_yandex: item.current.yandex_ws_unit_cnt,
					serp_unit: item.current.serp_unit_cnt,
					serp_unit_google: item.current.google_serp_unit_cnt,
					serp_unit_yandex: item.current.yandex_serp_unit_cnt,
					send_serp_data: item.current.send_serp_data,
					send_serp_yandex_cnt: item.current.send_serp_yandex_cnt,
					send_serp_google_cnt: item.current.send_serp_google_cnt,
					send_ws_data: item.current.send_ws_data,
					send_ws_yandex_cnt: item.current.send_ws_yandex_cnt,
					send_ws_google_cnt: item.current.send_ws_google_cnt,
					send_all_data: item.current.send_all_data,
					data_unit_limit: item.data_unit_limit,
					overrun: item.data_unit_limit ? item.overrun : 0
				}
			})
		},

		filteredTableItems () {
			console.log(this.showOnlyOverrun)
			if (!this.showOnlyOverrun) {
				return this.tableItems
			}

			return this.tableItems.filter(item => {
				return Number(item.overrun) > 0 && Number(item.data_unit_limit) > 0
			})
		},

		urlFilters () {
			const {
				client_ids,
				tariff_id,
				yandex_ws_unit_to,
				yandex_ws_unit_from,
				yandex_serp_unit_from,
				yandex_serp_unit_to,
				google_serp_unit_from,
				google_serp_unit_to,
				google_ws_unit_from,
				google_ws_unit_to,
				date_from,
				date_to,
				only_active_clients
			} = this.$route.query

			return {
				clientIds: validateFilterFromOptions(Array.isArray(client_ids) ? client_ids : [client_ids], this.clients, [], true, true),
				tariffId: tariff_id ? Number(tariff_id) : null,
				yandexWsUnitTo: yandex_ws_unit_to,
				yandexWsUnitFrom: yandex_ws_unit_from,
				yandexSerpUnitFrom: yandex_serp_unit_from,
				yandexSerpUnitTo: yandex_serp_unit_to,
				googleSerpUnitFrom: google_serp_unit_from,
				googleSerpUnitTo: google_serp_unit_to,
				googleWsUnitFrom: google_ws_unit_from,
				googleWsUnitTo: google_ws_unit_to,
				dateFrom: date_from,
				dateTo: date_to,
				onlyActiveClients: only_active_clients,
				filters
			}
		}
	},

	async created () {
		try {
			await this.getClients()
		} catch (_) {
			this.$notify({
				type: NOTIFY_STATUS.ERROR,
				title: errors.GET_DATA
			})
		} finally {
			this.loading.clients = false
		}
		await this.initDataTable()
	},

	watch: {
		async '$route.query' () {
			await this.initDataTable()
		}
	},

	methods: {
		...mapActions({
			getClientsStatisticsData: 'clientsStatistics/getClientsStatisticsData',
			getClients: 'getClients',
			updateLimitValue: 'clientsStatistics/updateLimitValue'
		}),

		async initDataTable () {
			const {
				clientIds,
				tariffId,
				yandexWsUnitTo,
				yandexWsUnitFrom,
				yandexSerpUnitFrom,
				yandexSerpUnitTo,
				googleSerpUnitFrom,
				googleSerpUnitTo,
				googleWsUnitFrom,
				googleWsUnitTo,
				dateFrom,
				dateTo,
				onlyActiveClients
			} = this.urlFilters

			this.loading.table = true
			await this.getClientsStatisticsData({
				query: {
					client_ids: clientIds,
					tariff_id: tariffId || undefined,
					yandex_ws_unit_to: yandexWsUnitTo || undefined,
					yandex_ws_unit_from: yandexWsUnitFrom || undefined,
					yandex_serp_unit_from: yandexSerpUnitFrom || undefined,
					yandex_serp_unit_to: yandexSerpUnitTo || undefined,
					google_serp_unit_from: googleSerpUnitFrom || undefined,
					google_serp_unit_to: googleSerpUnitTo || undefined,
					google_ws_unit_from: googleWsUnitFrom || undefined,
					google_ws_unit_to: googleWsUnitTo || undefined,
					date_from: dateFrom || undefined,
					date_to: dateTo || undefined,
					only_active_clients: onlyActiveClients ?? 1
				}
			})
			this.loading.table = false
		},

		async updateLimit (item, value) {
			await this.updateLimitValue({
				body: {
					client_id: item.client_id,
					data_unit_limit: value
				}
			})
		},

		downloadCsv () {
			const url = new URL('bridge/seowork/clients/statistics', this.$store.state.config.api.hqsw)

			const {
				clientIds,
				tariffId,
				yandexWsUnitTo,
				yandexWsUnitFrom,
				yandexSerpUnitFrom,
				yandexSerpUnitTo,
				googleSerpUnitFrom,
				googleSerpUnitTo,
				googleWsUnitFrom,
				googleWsUnitTo,
				dateFrom,
				dateTo,
				onlyActiveClients
			} = this.urlFilters

			const params = new URLSearchParams()

			;(clientIds ?? []).forEach((id, index) => {
				params.append(`client_ids[${index}]`, id)
			})

			tariffId && params.append('tariff_id', tariffId)
			yandexWsUnitTo && params.append('yandex_ws_unit_to', yandexWsUnitTo)
			yandexWsUnitFrom && params.append('yandex_ws_unit_from', yandexWsUnitFrom)
			yandexSerpUnitFrom && params.append('yandex_serp_unit_from', yandexSerpUnitFrom)
			yandexSerpUnitTo && params.append('yandex_serp_unit_to', yandexSerpUnitTo)
			googleSerpUnitFrom && params.append('google_serp_unit_from', googleSerpUnitFrom)
			googleSerpUnitTo && params.append('google_serp_unit_to', googleSerpUnitTo)
			googleWsUnitFrom && params.append('google_ws_unit_from', googleWsUnitFrom)
			googleWsUnitTo && params.append('google_ws_unit_to', googleWsUnitTo)
			dateFrom && params.append('date_from', dateFrom)
			dateTo && params.append('date_to', dateTo)
			onlyActiveClients && params.append('only_active_clients', onlyActiveClients ?? 1)
			params.append('download', 1)
			params.append('format', 'CSVWithNames')

			url.search = params.toString()

			const link = document.createElement('a')
			link.href = url.toString()

			document.body.appendChild(link)
			link.click()
			link.remove()
		}
	}
}
</script>

<style >
.clients-statistics-table {
	margin-top: 24px;
	border-top: 1px solid rgba(0,0,0,.12);
}
.overrun-red {
	background-color: #ff0000;
	color: #ffffff;
}
</style>
